import {TextStyle, RoundedRectangle} from 'pixi.js';

/* Can be overrided in game */
export const LSViewConfig = {
    sliderImagesList: [
        'preloader1_en', 'preloader2', 'preloader3_en', 'preloader4_en'
    ],

    textFeatureDescription: {
        position: {landscape: {x: 0, y: 300}, portrait: {x: 0, y: 300}},
        textFeatureTranslationsList: [
            'loadingScreenDescription1',
            'loadingScreenDescription2',
            'loadingScreenDescription3',
            'loadingScreenDescription4'
        ],
        defaultStyle: {
            fill: '#f9f5dc',
            fillGradientType: 1,
            fillGradientStops: [1],
            fontFamily: 'Arial Black',
            fontSize: 55,
            lineJoin: 'round' as 'miter' | 'round' | 'bevel',
            miterLimit: 1,
            stroke: '#dd1010',
            strokeThickness: 10,
            align: 'center' as const,
            verticalAlign: 'center' as const,
        } as Partial<TextStyle>
    },

    generalContainerParams: {
        position: {landscape: {x: 0, y: 100}, portrait: {x: 0, y: 350}},
        scale: {landscape: 0.3, portrait: 0.3},
    },

    preloaderBgParams: {
        size: {width: 1920, height: 1920},
        name: 'preloader_bg',
        color: 0x000000
    },

    logoParams: {
        position: {landscape: {x: 0, y: -250}, portrait: {x: 0, y: -250}},
        scale: {landscape: 1, portrait: 1},
        name: 'logo_en',
    },

    slidesParams: {
        position: {landscape: {x: 0, y: 0}, portrait: {x: 0, y: 0}},
        scale: {landscape: 1, portrait: 1},
        hitAreaArrows: null,
        hitAreaDots: null,
        autoSlideTime: 8000,
        defaultSlideTime: 8000,
        tweenAlphaTime: 300,
        dotsHide: false,
    },

    progressBar: {
        position: {landscape: {x: 0, y: 650}, portrait: {x: 0, y: 650}},
        scale: {landscape: 1, portrait: 1},
        frame: 'loading_bar_frame',
        full: 'loading_bar_full',
        empty: 'loading_bar_empty',
    },

    banner: {
        position: {landscape: {x: 0, y: 0}, portrait: {x: 0, y: 0}},
        scale: {landscape: 1, portrait: 1},
        completeBanner: 'preloader_press_txt',
        shouldShowBanner: false
    },

    startButtonParams: {
        position: {landscape: {x: 0, y: 650}, portrait: {x: 0, y: 650}},
        buttonName: 'preloader_button',
        scale: {landscape: 0.5, portrait: 0.5},
        maxWidth: 400,
        hitAreaStartButton: new RoundedRectangle(-275, -90, 550, 180, 45),
        showButtonWithText: true,
        localeID: 'buttonStart',
        shouldShowFullScreenButton: false,
        defaultStyle: {
            fontSize: 200,
            fontFamily: 'PF DinDisplay Pro',
            lineJoin: 'round' as const,
            fill: '#ffffff',
            stroke: '#000000',
            dropShadow: true,
            dropShadowDistance: 5,
            dropShadowAngle: Math.PI / 2,
            strokeThickness: 17,
            align: 'center' as const,
            verticalAlign: 'center' as const,
        } as Partial<TextStyle>
    },

    arrowButtonParams: {
        position: {landscape: {x: 1100, y: 0}, portrait: {x: 900, y: 0}},
        scale: 1,
        buttonName: 'arrow_btn',
    },

    dotButtonParams: {
        position: {landscape: {x: 0, y: 450}, portrait: {x: 0, y: 450}},
        scale: 1,
        dotOffset: 190,
        buttonName: 'dot_btn',
    },
};